import { Flex } from "@chakra-ui/react";
import React from "react";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";

export const TableBoxCollapse: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { collapseRef, isFullScreen, isExpanded } = useTableBoxContext();
  return (
    <Flex
      ref={collapseRef}
      alignItems="stretch"
      className="mb-tablebox-collapse"
      height="100%"
    >
      {isExpanded || isFullScreen ? children : null}
    </Flex>
  );
};
